module.exports = __webpack_public_path__ + "static/media/Globe.df04d6f2.svg";